(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('DocumentsContratController', DocumentsContratController);

    DocumentsContratController.$inject = ['$stateParams', 'entity'];

    function DocumentsContratController($stateParams, entity) {
        var vm = this;

        vm.idContrat = $stateParams.id;
        vm.contrat = entity;
    }
})();
